import React, {useEffect, useRef, useState} from 'react';
import {message, Radio} from 'antd';
import {useTranslation} from 'react-i18next';
import api from '../api';
import {Can} from '../helpers/Can';
import {ArtworkIcon} from '../helpers/icons';
import ConfigurableEntityIcon from '../configurable_entities/ConfigurableEntityIcon';

export default function TagTypeCell({tag, metadataEntityTypes = [], dispatch, onUpdated}) {
    const {t} = useTranslation();
    const [subType, setSubType] = useState(tag.sub_type);
    const confirmedSubType = useRef(tag.sub_type);
    const metadataEntityType = tag.metadata_entity_type || metadataEntityTypes.find(type => type.id === tag.metadata_entity_type_id);

    const onChange = value => {
        setSubType(value);
        api.put(`/api/tags/${tag.id}`, {tag: {sub_type: value}}).then(res => {
            if (res.data.errors) {
                setSubType(confirmedSubType.current);
                message.error(`${t('error','Error')}: ${JSON.stringify(res.data.errors)}`);
                return;
            }
            confirmedSubType.current = res.data.sub_type || value;
            setSubType(confirmedSubType.current);
            message.success(t('message-tag-updated','Tag updated'));
            dispatch({type:'updateTag', tag: {...tag, ...res.data}});
            onUpdated?.(res.data);
        }).catch(error => {
            setSubType(confirmedSubType.current);
            message.error(`${t('error','Error')}: ${error.response?.data?.error || error.message}`);
        });
    };

    useEffect(() => {
        confirmedSubType.current = tag.sub_type;
        setSubType(tag.sub_type);
    }, [tag.sub_type]);

    if (subType === 'artwork') {
        return <><ArtworkIcon style={{marginRight:'.3em'}}/> {t('artwork','Artwork')}</>;
    }

    if (subType === 'metadata_entity') {
        return <><ConfigurableEntityIcon icon={metadataEntityType?.icon} kind="metadata_entity"/> {metadataEntityType?.name || t('custom-metadata-entity','Custom Metadata Entity')}</>;
    }

    return (
        <Can I={'manage'} a={'Tag'} passThrough>
            {allowed => allowed ? (
                <Radio.Group
                    options={[{label:t('keyword','Keyword'), value:'keyword'}, {label:t('person','Person'), value:'person'}, {label:t('event','Event'), value:'event'},{label:t('product','Product'), value:'product'}]}
                    onChange={e => onChange(e.target.value)}
                    value={subType}
                    optionType="button"
                    size="small"
                />
            ) : subType?.toProperCase()}
        </Can>
    );
}
